import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Dumbbell, Target, Trophy, Heart, Users, TrendingUp, Brain, UserCheck, Smile, Globe, Shield, Zap, Activity, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TeenBenefitsPage() {
  const benefits = [{
    icon: Dumbbell,
    title: 'Physical Fitness',
    items: [{
      subtitle: 'Strength & Conditioning',
      description: 'Karate is a highly physical full-body workout, which helps improve strength, endurance, flexibility, and coordination.'
    }, {
      subtitle: 'Cardiovascular Health',
      description: 'Many karate and taekwondo exercises can improve cardiovascular fitness and promote overall health and well-being.'
    }, {
      subtitle: 'Weight Management',
      description: 'Regular training can help teens maintain a healthy weight and develop good habits for lifelong fitness.'
    }, {
      subtitle: 'Endurance',
      description: 'Over time, teens can build endurance skills, which can help them feel more confident and capable in other physical activities.'
    }]
  }, {
    icon: Target,
    title: 'Discipline & Focus',
    items: [{
      subtitle: 'Self-Control',
      description: 'Martial arts emphasize discipline and patience, which helps teens develop a strong sense of self-control.'
    }, {
      subtitle: 'Time Management',
      description: 'Training encourages the dedication of regular time commitment, improving time management and responsibility skills.'
    }, {
      subtitle: 'Focus',
      description: 'Practicing martial arts is often key to the mastery of specific techniques or attaining new belt levels, which enhances mental focus and concentration.'
    }]
  }, {
    icon: Trophy,
    title: 'Self-Confidence & Self-Esteem',
    items: [{
      subtitle: 'Karate',
      description: 'Karate and taekwondo can help teens develop a positive self-image through achieving goals and overcoming challenges.'
    }, {
      subtitle: 'Overcoming Challenges',
      description: 'Overcoming challenges and mastering difficult skills or techniques is rewarding and can build self-esteem.'
    }, {
      subtitle: 'Positive Self-Image',
      description: 'Teens who train in martial arts often feel more confident, which boosts self-esteem.'
    }]
  }, {
    icon: Heart,
    title: 'Emotional Regulation',
    items: [{
      subtitle: 'Stress Management',
      description: "Martial arts provide positive outlets to relieve stress or to boost teen's confidence under pressure. Intense workouts can also help manage anxiety and stress."
    }, {
      subtitle: 'Anger Management',
      description: 'The practice of martial arts teaches teens patience in diverse emotional states and teaches them self-control, which can help them manage anger and frustration.'
    }, {
      subtitle: 'Coping Skills',
      description: 'Teens are encouraged to develop healthy coping mechanisms for dealing with challenges, setbacks, and failures.'
    }]
  }, {
    icon: Users,
    title: 'Social Interaction & Respect',
    items: [{
      subtitle: 'Teamwork',
      description: 'Training in a team environment or group settings, where camaraderie and teamwork are important, helps teens develop social skills and build friendships.'
    }, {
      subtitle: 'Respect',
      description: 'Martial arts emphasize respect for instructors, peers, and opponents, teaching teens to respect others and themselves.'
    }, {
      subtitle: 'Communication Skills',
      description: 'Teenagers will develop social skills by interacting with peers, instructors, and fellow students in a structured, healthy environment.'
    }]
  }, {
    icon: TrendingUp,
    title: 'Goal Setting & Achievement',
    items: [{
      subtitle: 'Belt System',
      description: 'Teens learn to set goals (e.g., earning belts or achieving specific techniques) and work toward achieving them. This sense of accomplishment can boost confidence and motivation.'
    }, {
      subtitle: 'Personal Growth',
      description: 'Achieving goals in martial arts encourages teens to set and achieve goals in other areas of their lives, such as academics or personal projects.'
    }, {
      subtitle: 'Sense of Accomplishment',
      description: 'Reaching milestones in martial arts provides a sense of achievement that can motivate teens to continue working hard.'
    }]
  }, {
    icon: Brain,
    title: 'Mental Toughness & Resilience',
    items: [{
      subtitle: 'Perseverance',
      description: 'Martial arts training can be challenging and often requires perseverance. Learning to push will build resilience and mental toughness in the face of obstacles or when faced with adversity.'
    }, {
      subtitle: 'Handling Failure',
      description: 'Teens learn to accept failure as part of the learning process, helping them build a healthy relationship with setbacks and mistakes.'
    }, {
      subtitle: 'Adaptability',
      description: 'Martial arts teach teens how to adapt to new situations and challenges, fostering mental flexibility.'
    }]
  }, {
    icon: UserCheck,
    title: 'Respect for Authority',
    items: [{
      subtitle: 'Respect for Instructors',
      description: 'Martial arts typically teach teens to respect authority, which can be a valuable life skill. Instructors provide guidance and mentorship, teaching teens to value respect for authority in other areas of their lives.'
    }, {
      subtitle: 'Positive Role Models',
      description: 'Karate teachers often become positive role models for teens, helping them navigate challenges and make positive choices.'
    }]
  }, {
    icon: Smile,
    title: 'Stress Relief & Mental Clarity',
    items: [{
      subtitle: 'Physical Outlet',
      description: 'If the teenage years can be stressful due to academic or social pressures, martial arts provide a healthy outlet for releasing pent-up energy and stress.'
    }, {
      subtitle: 'Mindfulness',
      description: 'The focus required during training helps teens to "zone out" the stressors of daily life, providing mental clarity and a sense of calm.'
    }, {
      subtitle: 'Mental Clarity',
      description: 'The practice of concentration and focus creates an environment that clears the mind and promoting mental well-being.'
    }]
  }, {
    icon: Globe,
    title: 'Cultural Awareness (depending on the style)',
    items: [{
      subtitle: 'Exposure to Different Traditions',
      description: "Karate martial arts have their cultural roots (such as those found in Karate, Taekwondo, Kung Fu, etc. Brazilian Jiu-Jitsu, etc.), and this about these traditions can enhance a teen's global awareness and appreciation for different cultures."
    }]
  }, {
    icon: Shield,
    title: 'Prevention of Risky Behaviors',
    items: [{
      subtitle: 'Positive Outlet',
      description: "Teens's participation in martial arts can offer a constructive, structured outlet that may help reduce the likelihood of engaging in risky or negative behaviors."
    }, {
      subtitle: 'Structured Environment',
      description: 'The discipline of martial arts provides teens with a safe, structured environment that helps them avoid negative influences.'
    }, {
      subtitle: 'Healthy Lifestyle',
      description: 'Training encourages healthy habits and a focus on personal development, reducing the likelihood of engaging in harmful behaviors.'
    }]
  }, {
    icon: Zap,
    title: 'Fun & Motivation',
    items: [{
      subtitle: 'Enjoyment',
      description: 'Martial arts can be fun, engaging, and energizing. It challenges and a sense of achievement can keep teens motivated and excited about their training.'
    }, {
      subtitle: 'Sense of Achievement',
      description: 'The sense of accomplishment that comes with progressing in the art of karate and improving skills can provide teens with a sense of pride and fulfillment.'
    }, {
      subtitle: 'Variety',
      description: 'Martial arts offer a variety of techniques and styles to explore, keeping training interesting and engaging.'
    }]
  }];
  return <div className="bg-black min-h-screen" data-id="element-534">
      <Navigation data-id="element-535" />

      {/* Hero Section */}
      <div className="relative pt-20 pb-16 overflow-hidden" data-id="element-536">
        <div className="absolute inset-0 z-0" data-id="element-537">
          <img src="https://cdn.magicpatterns.com/uploads/qwuVaEXD8SYjhJLM9eceDG/teenbenefits.png" alt="Teen Benefits" className="w-full h-full object-cover opacity-20" data-id="element-538" />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black" data-id="element-539" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16" data-id="element-540">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center" data-id="element-541">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-542">
              Benefits for <span className="text-[#00D4FF]" data-id="element-543">Teenagers</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed" data-id="element-544">
              Walker's Martial Arts offers a wide range of benefits for
              teenagers, from physical health to mental well-being. Here's a
              breakdown of the key benefits:
            </p>
          </motion.div>
        </div>
      </div>

      {/* Benefits Sections */}
      <section className="py-20 bg-[#0a0a0a]" data-id="element-545">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-546">
          <div className="space-y-24" data-id="element-547">
            {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="relative" data-id="element-548">
                {/* Section Header */}
                <div className="flex items-center gap-4 mb-8" data-id="element-549">
                  <div className="flex items-center justify-center w-14 h-14 bg-[#00D4FF]/10 rounded-2xl border border-[#00D4FF]/30" data-id="element-550">
                    <benefit.icon className="w-7 h-7 text-[#00D4FF]" data-id="element-551" />
                  </div>
                  <div data-id="element-552">
                    <span className="text-[#00D4FF] font-bold text-lg" data-id="element-553">
                      {index + 1}.
                    </span>
                    <h2 className="text-3xl font-bold text-white inline ml-3" data-id="element-554">
                      {benefit.title}
                    </h2>
                  </div>
                </div>

                {/* Items */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ml-0 md:ml-18" data-id="element-555">
                  {benefit.items.map((item, itemIndex) => <motion.div key={item.subtitle} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: itemIndex * 0.1
              }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800 hover:border-[#00D4FF]/30 transition-colors" data-id="element-556">
                      <h3 className="text-lg font-bold text-white mb-3 flex items-start gap-2" data-id="element-557">
                        <Award className="w-5 h-5 text-[#00D4FF] flex-shrink-0 mt-0.5" data-id="element-558" />
                        {item.subtitle}
                      </h3>
                      <p className="text-gray-400 leading-relaxed text-sm" data-id="element-559">
                        {item.description}
                      </p>
                    </motion.div>)}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Summary Section */}
      <section className="py-20 bg-black" data-id="element-560">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-561">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-562">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#00D4FF]/10 rounded-full mb-6" data-id="element-563">
              <Heart className="w-8 h-8 text-[#00D4FF]" data-id="element-564" />
            </div>
            <p className="text-2xl text-gray-300 leading-relaxed mb-12" data-id="element-565">
              Walker's Martial Arts offers an exceptional approach to physical
              fitness, mental resilience, and personal development for teens.
              Our programs can help build confidence, self-discipline, and
              leadership skills while fostering respect for themselves and
              others.
            </p>

            <div className="bg-gradient-to-r from-[#00D4FF]/10 to-transparent p-8 rounded-2xl border border-[#00D4FF]/20 mb-12" data-id="element-566">
              <p className="text-xl text-white font-semibold mb-6" data-id="element-567">
                We invite you to try a complimentary class
              </p>
              <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#00D4FF] text-black font-bold rounded-full hover:bg-[#00D4FF]/90 transition-colors" data-id="element-568">
                <Activity className="w-5 h-5" data-id="element-569" />
                Complimentary Class
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-570" />
    </div>;
}